import { createSelector } from "reselect";
import { getQuotesEntities } from "../../api/policies/selectors";
import { EMPTY_OBJECT } from "../../emptyState";

const getPolicyId = (_, props) => props.match.params.sipasuuid;

export const getQuote = createSelector(getQuotesEntities, getPolicyId, (quotes = EMPTY_OBJECT, id) =>
  quotes[id] ? quotes[id] : EMPTY_OBJECT,
);
